/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type RoomAdaptDeviceFragment = { id: string, status: Types.DeviceStatus, virtual: boolean, description: { features: { roomCharacterization: { supported: boolean }, roomAdapt: { supported: boolean } } }, features: { name: { name: string } | null, room: { room: { id: string, name: string } | null } | null, roomCharacterization: { readiness: boolean, reportDownloadAvailable: boolean, summary: { ambientNoise: number, coupling: number, distortion: number, reverberation: number, signalContinuityResult: Types.SignalContinuityResult | null, autoRouteResult: Types.AutoRouteResult | null, characterizationMeasurementResult: Types.CharacterizationMeasurementResult | null, characterizationReportResult: Types.CharacterizationReportResult | null } | null } | null, roomAdapt: { status: Types.RoomAdaptStatus } | null } };

export type RoomAdaptDeviceChangeFragment = { id: string, features: { name: { name: string } | null } | { roomAdapt: { status: Types.RoomAdaptStatus } | null } | { room: { room: { id: string, name: string } | null } | null } | { roomCharacterization: { readiness: boolean, reportDownloadAvailable: boolean, summary: { ambientNoise: number, coupling: number, distortion: number, reverberation: number, signalContinuityResult: Types.SignalContinuityResult | null, autoRouteResult: Types.AutoRouteResult | null, characterizationMeasurementResult: Types.CharacterizationMeasurementResult | null, characterizationReportResult: Types.CharacterizationReportResult | null } | null } | null } | {} };

export type RoomAdaptAutoRouteResultEventFragment = { autoRouteResult: Types.AutoRouteResult };

export type RoomAdaptSignalContinuityResultEventFragment = { signalContinuityResult: Types.SignalContinuityResult };

export type RoomAdaptCharacterizationReportResultEventFragment = { characterizationReportResult: Types.CharacterizationReportResult };

export type RoomAdaptCharacterizationMeasurementResultEventFragment = { characterizationMeasurementResult: Types.CharacterizationMeasurementResult };

export type RoomAdaptSummaryEventFragment = { summary: { ambientNoise: number, coupling: number, distortion: number, reverberation: number, signalContinuityResult: Types.SignalContinuityResult | null, autoRouteResult: Types.AutoRouteResult | null, characterizationMeasurementResult: Types.CharacterizationMeasurementResult | null, characterizationReportResult: Types.CharacterizationReportResult | null } };

export type RoomAdaptRoomDevicesFragment = { devices: Array<{ id: string, status: Types.DeviceStatus, virtual: boolean, description: { features: { roomCharacterization: { supported: boolean } } } }> };

export type GetRoomAdaptDeviceQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['ID']['input'];
}>;


export type GetRoomAdaptDeviceQueryOpResult = { node: RoomAdaptDeviceFragment | {} };

export type GetRoomAdaptRoomDevicesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetRoomAdaptRoomDevicesQueryOpResult = { node: RoomAdaptRoomDevicesFragment | {} };

export type RoomAdaptDeviceSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type RoomAdaptDeviceSubscriptionOpResult = { nodeChanges: RoomAdaptDeviceFragment | RoomAdaptDeviceChangeFragment | {} };

export type RoomAdaptStatusSubscriptionVariables = Types.Exact<{
  input: Types.RoomCharacterizationInput;
}>;


export type RoomAdaptStatusSubscriptionOpResult = { roomCharacterizationStatus: RoomAdaptAutoRouteResultEventFragment | RoomAdaptCharacterizationMeasurementResultEventFragment | RoomAdaptCharacterizationReportResultEventFragment | RoomAdaptSummaryEventFragment | RoomAdaptSignalContinuityResultEventFragment };

export type RoomAdaptRoomDevicesSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type RoomAdaptRoomDevicesSubscriptionOpResult = { nodeChanges: RoomAdaptRoomDevicesFragment | {} };

export type StartRoomAdaptMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type StartRoomAdaptMutationOpResult = { startRoomCharacterization: { success: boolean, error: { code: Types.ErrorCode, message: string } | null } };

export type AbortRoomAdaptMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type AbortRoomAdaptMutationOpResult = { abortRoomCharacterization: { success: boolean, error: { code: Types.ErrorCode, message: string } | null } };

export type RetrieveRoomCharacterizationReportMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RetrieveRoomCharacterizationReportMutationOpResult = { retrieveRoomCharacterizationReport: { fileContents: string | null, error: { code: Types.ErrorCode, message: string } | null } };

export type GetDeviceNamesQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type GetDeviceNamesQueryOpResult = { nodes: Array<{ id: string, features: { name: { name: string } | null } } | {} | null> };

export const RoomAdaptDeviceFragment = gql`
    fragment RoomAdaptDeviceFragment on Device {
  id
  status
  virtual
  description {
    features {
      roomCharacterization {
        supported
      }
      roomAdapt {
        supported
      }
    }
  }
  features {
    name {
      name
    }
    room {
      room {
        id
        name
      }
    }
    roomCharacterization {
      readiness
      reportDownloadAvailable
      summary {
        ambientNoise
        coupling
        distortion
        reverberation
        signalContinuityResult
        autoRouteResult
        characterizationMeasurementResult
        characterizationReportResult
      }
    }
    roomAdapt {
      status
    }
  }
}
    `;
export const RoomAdaptDeviceChangeFragment = gql`
    fragment RoomAdaptDeviceChangeFragment on DeviceChange {
  id
  features {
    ... on DeviceNameChange {
      name {
        name
      }
    }
    ... on DeviceRoomChange {
      room {
        room {
          id
          name
        }
      }
    }
    ... on DeviceRoomCharacterizationChange {
      roomCharacterization {
        readiness
        reportDownloadAvailable
        summary {
          ambientNoise
          coupling
          distortion
          reverberation
          signalContinuityResult
          autoRouteResult
          characterizationMeasurementResult
          characterizationReportResult
        }
      }
    }
    ... on DeviceRoomAdaptChange {
      roomAdapt {
        status
      }
    }
  }
}
    `;
export const RoomAdaptAutoRouteResultEventFragment = gql`
    fragment RoomAdaptAutoRouteResultEventFragment on AutoRouteResultEvent {
  autoRouteResult
}
    `;
export const RoomAdaptSignalContinuityResultEventFragment = gql`
    fragment RoomAdaptSignalContinuityResultEventFragment on SignalContinuityResultEvent {
  signalContinuityResult
}
    `;
export const RoomAdaptCharacterizationReportResultEventFragment = gql`
    fragment RoomAdaptCharacterizationReportResultEventFragment on CharacterizationReportResultEvent {
  characterizationReportResult
}
    `;
export const RoomAdaptCharacterizationMeasurementResultEventFragment = gql`
    fragment RoomAdaptCharacterizationMeasurementResultEventFragment on CharacterizationMeasurementResultEvent {
  characterizationMeasurementResult
}
    `;
export const RoomAdaptSummaryEventFragment = gql`
    fragment RoomAdaptSummaryEventFragment on RoomCharacterizationSummaryEvent {
  summary {
    ambientNoise
    coupling
    distortion
    reverberation
    signalContinuityResult
    autoRouteResult
    characterizationMeasurementResult
    characterizationReportResult
  }
}
    `;
export const RoomAdaptRoomDevicesFragment = gql`
    fragment RoomAdaptRoomDevicesFragment on Room {
  devices {
    id
    status
    virtual
    description {
      features {
        roomCharacterization {
          supported
        }
      }
    }
  }
}
    `;
export const GetRoomAdaptDeviceQueryDocument = gql`
    query GetRoomAdaptDeviceQuery($deviceId: ID!) {
  node(id: $deviceId) {
    ...RoomAdaptDeviceFragment
  }
}
    ${RoomAdaptDeviceFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRoomAdaptDeviceQueryGQL extends Apollo.Query<GetRoomAdaptDeviceQueryOpResult, GetRoomAdaptDeviceQueryVariables> {
    override document = GetRoomAdaptDeviceQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRoomAdaptRoomDevicesQueryDocument = gql`
    query GetRoomAdaptRoomDevicesQuery($id: ID!) {
  node(id: $id) {
    ...RoomAdaptRoomDevicesFragment
  }
}
    ${RoomAdaptRoomDevicesFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRoomAdaptRoomDevicesQueryGQL extends Apollo.Query<GetRoomAdaptRoomDevicesQueryOpResult, GetRoomAdaptRoomDevicesQueryVariables> {
    override document = GetRoomAdaptRoomDevicesQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoomAdaptDeviceSubscriptionDocument = gql`
    subscription RoomAdaptDeviceSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...RoomAdaptDeviceFragment
    ...RoomAdaptDeviceChangeFragment
  }
}
    ${RoomAdaptDeviceFragment}
${RoomAdaptDeviceChangeFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RoomAdaptDeviceSubscriptionGQL extends Apollo.Subscription<RoomAdaptDeviceSubscriptionOpResult, RoomAdaptDeviceSubscriptionVariables> {
    override document = RoomAdaptDeviceSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoomAdaptStatusSubscriptionDocument = gql`
    subscription RoomAdaptStatusSubscription($input: RoomCharacterizationInput!) {
  roomCharacterizationStatus(input: $input) {
    ...RoomAdaptAutoRouteResultEventFragment
    ...RoomAdaptSignalContinuityResultEventFragment
    ...RoomAdaptCharacterizationMeasurementResultEventFragment
    ...RoomAdaptCharacterizationReportResultEventFragment
    ...RoomAdaptSummaryEventFragment
  }
}
    ${RoomAdaptAutoRouteResultEventFragment}
${RoomAdaptSignalContinuityResultEventFragment}
${RoomAdaptCharacterizationMeasurementResultEventFragment}
${RoomAdaptCharacterizationReportResultEventFragment}
${RoomAdaptSummaryEventFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RoomAdaptStatusSubscriptionGQL extends Apollo.Subscription<RoomAdaptStatusSubscriptionOpResult, RoomAdaptStatusSubscriptionVariables> {
    override document = RoomAdaptStatusSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoomAdaptRoomDevicesSubscriptionDocument = gql`
    subscription RoomAdaptRoomDevicesSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...RoomAdaptRoomDevicesFragment
  }
}
    ${RoomAdaptRoomDevicesFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RoomAdaptRoomDevicesSubscriptionGQL extends Apollo.Subscription<RoomAdaptRoomDevicesSubscriptionOpResult, RoomAdaptRoomDevicesSubscriptionVariables> {
    override document = RoomAdaptRoomDevicesSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StartRoomAdaptMutationDocument = gql`
    mutation StartRoomAdaptMutation($id: ID!, $injectKeyring: String) {
  startRoomCharacterization(input: {id: $id}, keyring: $injectKeyring) {
    success
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StartRoomAdaptMutationGQL extends Apollo.Mutation<StartRoomAdaptMutationOpResult, StartRoomAdaptMutationVariables> {
    override document = StartRoomAdaptMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AbortRoomAdaptMutationDocument = gql`
    mutation AbortRoomAdaptMutation($id: ID!, $injectKeyring: String) {
  abortRoomCharacterization(input: {id: $id}, keyring: $injectKeyring) {
    success
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AbortRoomAdaptMutationGQL extends Apollo.Mutation<AbortRoomAdaptMutationOpResult, AbortRoomAdaptMutationVariables> {
    override document = AbortRoomAdaptMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RetrieveRoomCharacterizationReportMutationDocument = gql`
    mutation RetrieveRoomCharacterizationReportMutation($id: ID!) {
  retrieveRoomCharacterizationReport(input: {id: $id}) {
    fileContents
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RetrieveRoomCharacterizationReportMutationGQL extends Apollo.Mutation<RetrieveRoomCharacterizationReportMutationOpResult, RetrieveRoomCharacterizationReportMutationVariables> {
    override document = RetrieveRoomCharacterizationReportMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDeviceNamesQueryDocument = gql`
    query GetDeviceNamesQuery($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Device {
      id
      features {
        name {
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDeviceNamesQueryGQL extends Apollo.Query<GetDeviceNamesQueryOpResult, GetDeviceNamesQueryVariables> {
    override document = GetDeviceNamesQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }